"use client";
import React from "react";
import PropTypes from "prop-types";
import { Header } from "semantic-ui-react";

import { styles, styles1 } from "./element";

const InText = ({ name, colorClass, ...props }) => (
  <Header
    size="small"
    content={name}
    {...props}
    style={colorClass ? styles1.text_color : styles}
  />
);

InText.propTypes = {
  name: PropTypes.string,
};
export default InText;
